import React, { FC, useEffect, useRef, useState } from 'react'

import {
  FilterAccordion,
  SwitchButton,
  useIsTabletOrMobile,
  useOnClickOutside,
} from '@avantstay/backoffice-core'

import { FiltersSharedProps } from '../Filters.types'

interface SwitchBasedFilterProps extends FiltersSharedProps {
  title: string
  initialValue?: boolean
  onChange: (value?: boolean) => void
}

export const SwitchBasedFilter: FC<SwitchBasedFilterProps> = ({
  title,
  initialValue,
  isSidebarFilter,
  onChange,
}) => {
  const [localValue, setLocalValue] = useState<boolean | undefined>(initialValue)

  const isTabletOrMobile = useIsTabletOrMobile()

  const wrapperRef = useRef<HTMLDivElement>(null)

  const handleSubmitValue = () => {
    if (localValue !== initialValue) {
      onChange(localValue)
    }
  }

  useOnClickOutside(wrapperRef, handleSubmitValue)

  useEffect(() => {
    if (!initialValue) {
      setLocalValue(initialValue)
    }
  }, [initialValue])

  useEffect(() => {
    if (isSidebarFilter) {
      handleSubmitValue()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [localValue, isSidebarFilter])

  // This clears selection when we run propertiesListStore.resetFilters
  useEffect(() => {
    if (initialValue === undefined) {
      setLocalValue(undefined)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [initialValue])

  const handleOnClear = () => {
    onChange(false)
    setLocalValue(false)
  }

  return (
    <FilterAccordion
      title={title}
      onClearFilter={handleOnClear}
      ref={wrapperRef}
      filterValue={localValue}
      isInlineFilter={isTabletOrMobile || isSidebarFilter}
      isSidebarFilter={isSidebarFilter}
      shouldShowClearButton={false}
      hideFilterTag
    >
      <SwitchButton
        titleLeft={isSidebarFilter || isTabletOrMobile ? '' : title}
        id={title}
        checked={!!localValue}
        onChange={event => setLocalValue(event.currentTarget.checked)}
      />
    </FilterAccordion>
  )
}
